import { Component } from '@angular/core';

@Component({
  moduleId:    module.id,
  selector: 'groovy-task',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent  {
  name = 'GroovyTask';
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts